import React from 'react';
import { Bonuses } from './components/Bonuses';
import { EliteComparison } from './components/EliteComparison';
import { Faq } from './components/Faq';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { FullTestimonials } from './components/FullTestimonials';
import { GuaranteeAndCost } from './components/GuaranteeAndCost';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { PainAndTransformation } from './components/PainAndTransformation';
import { Pricing } from './components/Pricing';
import { ProductOverview } from './components/ProductOverview';
import { Testimonials } from './components/Testimonials';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink text-zinc-300 selection:bg-gold selection:text-ink" data-id="element-0" data-mp="28tw44o8wqe1v">
      <MetaPixel data-id="element-1" data-mp="23u9vks40xlze" />
      <TopBar data-id="element-2" data-mp="23ut9zyugts8o" />
      <main data-id="element-3" data-mp="23t8iki3g6pf1">
        <Hero data-id="element-4" data-mp="23ti5txx3yih1" />
        <Testimonials data-id="element-5" data-mp="3ik7eyd5x05p2" />
        <PainAndTransformation data-id="element-6" data-mp="3iiwdijzxza14" />
        <ProductOverview data-id="element-7" data-mp="3ijpd910hgz9r" />
        <Bonuses data-id="element-8" data-mp="3mljat0fdtn5p" />
        <Pricing data-id="element-9" data-mp="3ml1419v3fqjj" />
        <EliteComparison data-id="element-10" data-mp="3mkhmhu9cv461" />
        <FullTestimonials data-id="element-11" data-mp="3mjq1fdddwou0" />
        <Faq data-id="element-12" data-mp="3mj6lu3b7icj5" />
        <GuaranteeAndCost data-id="element-13" data-mp="3rcj7c4kla37o" />
      </main>
      <Footer data-id="element-14" data-mp="3rdkh85pvcjnt" />
      <FloatingElements data-id="element-15" data-mp="3rd1a7k1rbfok" />
      <noscript data-id="element-16" data-mp="5yk6vxnnffx">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-17" data-mp="5opww5kum4f" />
      </noscript>
    </div>;
}